import React, { Component } from "react";
import "./salesSearchBox.css";
import DatePicker from "react-datepicker";
import Moment from "moment";

var isNmscUser = false;
class SalesSearchBox extends Component {
  componentDidUpdate() {
    console.log("search data is=", this.props.data);
  }
  render() {
    return (
      <div>
        <form onSubmit={this.props.onSearchHandler}>
          <div className="row SalescontentData">
            <div
              className="col-md-12 col-sm-12 col-xs-12 form-horizontal"
              style={{ marginTop: "0.5%", marginBottom: "-0.5%" }}
            >
              <div className="form-group row">
                <div className="row col-md-4">
                  <div className="inputField">
                    <i
                      className="fa fa-search"
                      aria-hidden="true"
                      style={{ marginLeft: "1px" }}
                    ></i>
                    <select
                      autoComplete="off"
                      className={
                        this.props.data.typeOfInvoice === ""
                          ? "SalesPlaceholder"
                          : "form-control"
                      }
                      name="typeOfInvoice"
                      value={this.props.data.typeOfInvoice}
                      onChange={this.props.onChangeHandler}
                    >
                      {this.props.InvoicesType.map((ele, key) => {
                        return (
                          <option
                            className="form-control"
                            key={key}
                            value={ele.value}
                          >
                            {ele.label}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                  {this.props.data.typeOfInvoice === "" ? (
                    <p className="errorMessage" style={{ top: "102%" }}>
                      *Required
                    </p>
                  ) : null}
                </div>
                <div className="row col-md-4">
                  <div className="inputField">
                    <i
                      className="fa fa-search"
                      aria-hidden="true"
                      style={{ marginLeft: "1px" }}
                    ></i>
                    <select
                      autoComplete="off"
                      className={
                        this.props.data.source === ""
                          ? "SalesPlaceholder"
                          : "form-control"
                      }
                      name="source"
                      value={this.props.data.source}
                      onChange={this.props.onChangeHandler}
                    >
                      <option className="form-control" value="">
                        SELECT SUPPLIER NAME
                      </option>
                      {this.props.SOURCE.map((ele, key) => {
                        return (
                          <option
                            className="form-control"
                            key={key}
                            value={ele.value}
                          >
                            {ele.value} - {ele.label}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>

                {this.props.roles.includes("EDOC VLG NMSC USER") ? (
                  <div className="row col-md-4">
                    <div className="inputField">
                      <i
                        className="fa fa-search"
                        aria-hidden="true"
                        style={{ marginLeft: "1px" }}
                      ></i>
                      <input
                        className="form-control"
                        autoComplete="off"
                        type="text"
                        name="edNumber"
                        placeholder="INPUT ED NUMBER"
                        value={this.props.data.edNumber}
                        onChange={this.props.onChangeHandler}
                      />
                    </div>
                  </div>
                ) : (
                  <div className="row col-md-4">
                    <div className="inputField">
                      <i
                        className="fa fa-search"
                        aria-hidden="true"
                        style={{ marginLeft: "1px" }}
                      ></i>
                      <select
                        autoComplete="off"
                        className={
                          this.props.data.nmsc === ""
                            ? "SalesPlaceholder"
                            : "form-control"
                        }
                        name="nmsc"
                        value={this.props.data.nmsc}
                        onChange={this.props.onChangeHandler}
                      >
                        <option className="form-control" value="">
                          SELECT NMSC
                        </option>
                        {this.props.VLGNMSC.map((ele, key) => {
                          return (
                            <option
                              className="form-control"
                              key={key}
                              value={ele.value}
                            >
                              {ele.value} - {ele.label}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                )}
              </div>
              <div className="form-group row">
                <div className="row col-md-4">
                  <div className="inputField">
                    <i
                      className="fa fa-search"
                      aria-hidden="true"
                      style={{ marginLeft: "1px" }}
                    ></i>
                    <input
                      className="form-control"
                      autoComplete="off"
                      type="text"
                      name="invoiceNumber"
                      placeholder="INPUT INVOICE NUMBER"
                      value={this.props.data.invoiceNumber}
                      onChange={this.props.onChangeHandler}
                    />
                  </div>
                </div>
                <div className="row col-md-4">
                  <div className="inputField">
                    <i
                      className="fa fa-search"
                      aria-hidden="true"
                      style={{ marginLeft: "1px" }}
                    ></i>
                    <DatePicker
                      dateFormat="YYYY-MM-DD"
                      id="invoiceFromDate"
                      autoComplete="off"
                      className="form-control"
                      name="invoiceFromDate"
                      selected={
                        this.props.data.invoiceFromDate
                          ? Moment(this.props.data.invoiceFromDate)
                          : null
                      }
                      onChange={(d) =>
                        this.props.invoiceDateChangeHandler(
                          d,
                          "invoiceFromDate"
                        )
                      }
                      placeholderText="SELECT INVOICE DATE (FROM)"
                    />
                  </div>
                </div>

                <div className="row col-md-4">
                  <div className="inputField">
                    <i
                      className="fa fa-search"
                      aria-hidden="true"
                      style={{ marginLeft: "1px" }}
                    ></i>
                    <DatePicker
                      dateFormat="YYYY-MM-DD"
                      id="invoiceToDate"
                      autoComplete="off"
                      className="form-control"
                      name="invoiceToDate"
                      selected={
                        this.props.data.invoiceToDate
                          ? Moment(this.props.data.invoiceToDate)
                          : null
                      }
                      onChange={(d) =>
                        this.props.invoiceDateChangeHandler(d, "invoiceToDate")
                      }
                      placeholderText="SELECT INVOICE DATE (TO)"
                    />
                  </div>
                  <p className="errorMessage" style={{ top: "102%" }}>
                    {this.props.data.toDateErr}
                  </p>
                </div>
              </div>
              <div className="form-group row">
                <div className="row col-md-4">
                  <div className="inputField">
                    <i
                      className="fa fa-search"
                      aria-hidden="true"
                      style={{ marginLeft: "1px" }}
                    ></i>
                    <input
                      className="form-control"
                      type="text"
                      autoComplete="off"
                      name="vinNumber"
                      placeholder="INPUT VIN NUMBER"
                      value={this.props.data.vinNumber}
                      onChange={this.props.onChangeHandler}
                    />
                  </div>
                </div>

                <div className="row col-md-4">
                  <div className="inputField">
                    <i
                      className="fa fa-search"
                      aria-hidden="true"
                      style={{ marginLeft: "1px" }}
                    ></i>
                    <select
                      autoComplete="off"
                      className={
                        this.props.data.vesselName === ""
                          ? "SalesPlaceholder"
                          : "form-control"
                      }
                      name="vesselName"
                      value={this.props.data.vesselName}
                      onChange={this.props.onChangeHandler}
                    >
                      <option className="form-control" value="">
                        SELECT VESSEL NAME
                      </option>
                      {this.props.VESSELNAME.map((ele, key) => {
                        return (
                          <option
                            className="form-control"
                            key={key}
                            value={ele}
                          >
                            {ele}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>

                {this.props.roles.includes("EDOC VLG NMSC USER") ? null : (
                  <div className="row col-md-4">
                    <div className="inputField">
                      <i
                        className="fa fa-search"
                        aria-hidden="true"
                        style={{ marginLeft: "1px" }}
                      ></i>
                      <input
                        className="form-control"
                        autoComplete="off"
                        type="text"
                        name="edNumber"
                        placeholder="INPUT ED NUMBER"
                        value={this.props.data.edNumber}
                        onChange={this.props.onChangeHandler}
                      />
                    </div>
                  </div>
                )}
              </div>

              <div className="form-group row">
                {!this.props.roles.includes("EDOC TME AF USER") ? null : (
                  <div className="row col-md-4">
                    <div className="inputField">
                      <i
                        className="fa fa-search"
                        aria-hidden="true"
                        style={{ marginLeft: "1px" }}
                      ></i>
                      <select
                        autoComplete="off"
                        className={
                          this.props.data.srcVatCode === ""
                            ? "SalesPlaceholder"
                            : "form-control"
                        }
                        name="srcVatCode"
                        value={this.props.data.srcVatCode}
                        onChange={this.props.onChangeHandler}
                      >
                        <option className="form-control" value="">
                          SELECT SRC VAT CODE
                        </option>
                        {this.props.SRCVATCODE.map((ele, key) => {
                          return (
                            <option
                              className="form-control"
                              key={key}
                              value={ele}
                            >
                              {ele}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                )}

                {!this.props.roles.includes("EDOC TME AF USER") ? null : (
                  <div className="row col-md-4">
                    <div className="inputField">
                      <i
                        className="fa fa-search"
                        aria-hidden="true"
                        style={{ marginLeft: "1px" }}
                      ></i>
                      <select
                        autoComplete="off"
                        className={
                          this.props.data.tgtVatCode === ""
                            ? "SalesPlaceholder"
                            : "form-control"
                        }
                        name="tgtVatCode"
                        value={this.props.data.tgtVatCode}
                        onChange={this.props.onChangeHandler}
                      >
                        <option className="form-control" value="">
                          SELECT TGT VAT CODE
                        </option>
                        {this.props.TGTVATCODE.map((ele, key) => {
                          return (
                            <option
                              className="form-control"
                              key={key}
                              value={ele}
                            >
                              {ele}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                )}

                {/* {this.props.roles.includes("EDOC VLG NMSC USER") ? null : (
                  <div className="row col-md-4">
                    <div className="inputField">
                      <i
                        className="fa fa-search"
                        aria-hidden="true"
                        style={{ marginLeft: "1px" }}
                      ></i>
                      <select
                        autoComplete="off"
                        className={
                          this.props.data.hub === ""
                            ? "SalesPlaceholder"
                            : "form-control"
                        }
                        name="hub"
                        value={this.props.data.hub}
                        onChange={this.props.onChangeHandler}
                      >
                        <option className="form-control" value="">
                          SELECT HUB
                        </option>
                        {this.props.VLGHUB.map((ele, key) => {
                          return (
                            <option
                              className="form-control"
                              key={key}
                              value={ele}
                            >
                              {ele}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                )} */}
              </div>

              <div
                className="form-group row pull-right"
                style={{
                  marginTop: "0.5%",
                  fontFamily: "Roboto",
                  color: "white",
                  fontSize: "14px",
                }}
              >
                <div>
                  <button
                    className="btn btn-danger"
                    // disabled={this.props.data.search}
                    type="submit"
                    disabled={
                      this.props.data.typeOfInvoice === "" ||
                      !(this.props.data.toDateErr === "") ||
                      this.props.OneRandomInput
                        ? true
                        : false
                    }
                    style={{
                      borderRadius: "20px",
                      backgroundColor: "#E50000",
                      height: "39px",
                    }}
                  >
                    {/* <i
                    className="fa fa-spinner fa-spin"
                    style={{ marginLeft: "1px" }}
                  ></i> */}
                    SEARCH
                  </button>{" "}
                  &nbsp;&nbsp;&nbsp;
                  {/* </div> */}
                  {/* <div className="col-md-3 col-sm-3 col-xs-3"> */}
                  <input
                    type="button"
                    className="btn"
                    value="CLEAR"
                    onClick={this.props.onClear}
                    style={{
                      borderRadius: "20px",
                      backgroundColor: "#E50000",
                      color: "white",
                      height: "39px",
                    }}
                  />
                  {this.props.data.typeOfInvoice === "" ? (
                    <p className="errorMessage">(Fill required field)</p>
                  ) : this.props.OneRandomInput ? (
                    <p className="errorMessage">
                      (Select atleast 1 more field)
                    </p>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

export default SalesSearchBox;
